"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _freeze = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/freeze"));
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));
var _chainFunction = _interopRequireDefault(require("chain-function"));
var _bind = _interopRequireDefault(require("classnames/bind"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _reactUiTheming = require("@concur/react-ui-theming");
var _AlertDialogContext = _interopRequireDefault(require("../utils/_AlertDialogContext"));
var _Modal = _interopRequireDefault(require("../Modal/Modal"));
var _Icon = _interopRequireDefault(require("../Icon/Icon"));
var _Button = _interopRequireDefault(require("../Buttons/Button"));
var _CustomPropTypes = _interopRequireDefault(require("../utils/CustomPropTypes"));
var _StyleConfig = require("../utils/StyleConfig");
var _MessageBoxConcur_android = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./MessageBox-concur_android.css") : void 0);
var _MessageBoxConcur_default = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./MessageBox-concur_default.css") : void 0);
var _MessageBoxConcur_gateway = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./MessageBox-concur_gateway.css") : void 0);
var _MessageBoxConcur_ios = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./MessageBox-concur_ios.css") : void 0);
var _MessageBoxSap_fiori_3_dark = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./MessageBox-sap_fiori_3_dark.css") : void 0);
var _MessageBoxSap_fiori_3_hcb = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./MessageBox-sap_fiori_3_hcb.css") : void 0);
var _MessageBoxSap_fiori_3_hcw = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./MessageBox-sap_fiori_3_hcw.css") : void 0);
var _MessageBoxSap_fiori_ = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./MessageBox-sap_fiori_3.css") : void 0);
var _MessageBoxSap_horizon_dark = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./MessageBox-sap_horizon_dark.css") : void 0);
var _MessageBoxSap_horizon_hcb = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./MessageBox-sap_horizon_hcb.css") : void 0);
var _MessageBoxSap_horizon_hcw = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./MessageBox-sap_horizon_hcw.css") : void 0);
var _MessageBoxSap_horizon = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./MessageBox-sap_horizon.css") : void 0);
var _excluded = ["type", "backdropClassName", "buttonPrimary", "buttonSecondary", "buttonNegative", "buttonSize", "children", "className", "classNameMap", "closeButtonLabel", "onHide", "hideCloseButton", "title"],
  _excluded2 = ["text", "onClick"];
/* eslint-disable react/no-multi-comp */
var styles = {
  concur_android: _MessageBoxConcur_android.default,
  concur_default: _MessageBoxConcur_default.default,
  concur_gateway: _MessageBoxConcur_gateway.default,
  concur_ios: _MessageBoxConcur_ios.default,
  sap_fiori_3_dark: _MessageBoxSap_fiori_3_dark.default,
  sap_fiori_3_hcb: _MessageBoxSap_fiori_3_hcb.default,
  sap_fiori_3_hcw: _MessageBoxSap_fiori_3_hcw.default,
  sap_fiori_3: _MessageBoxSap_fiori_.default,
  sap_horizon_dark: _MessageBoxSap_horizon_dark.default,
  sap_horizon_hcb: _MessageBoxSap_horizon_hcb.default,
  sap_horizon_hcw: _MessageBoxSap_horizon_hcw.default,
  sap_horizon: _MessageBoxSap_horizon.default
};
(0, _freeze.default)(styles);
var CSS_BLOCK = 'sapcnqr-messagebox';

/**
 * The **MessageBox** component notifies users of an event. The **MessageBox** appears as an
 * overlay on the screen and requires a response from the user before work can be resumed.
 *
 * See the [Patterns/Message Handling](./?path=/docs/patterns-message-handling--docs) page
 * for more detailed information on selecting the appropriate messaging component.
 */

var MessageBox = /*#__PURE__*/_react.default.forwardRef(function (props, ref) {
  var type = props.type,
    backdropClassName = props.backdropClassName,
    buttonPrimary = props.buttonPrimary,
    buttonSecondary = props.buttonSecondary,
    buttonNegative = props.buttonNegative,
    buttonSize = props.buttonSize,
    children = props.children,
    className = props.className,
    classNameMap = props.classNameMap,
    closeButtonLabel = props.closeButtonLabel,
    onHide = props.onHide,
    hideCloseButton = props.hideCloseButton,
    title = props.title,
    otherProps = (0, _objectWithoutProperties2.default)(props, _excluded);
  var classnames = _bind.default.bind(classNameMap);
  var classes = classnames(CSS_BLOCK, className);
  var backdropClasses = classnames("".concat(CSS_BLOCK, "__backdrop"), backdropClassName);
  var bodyClasses = classnames(_StyleConfig.CSS_PREFIX, "".concat(CSS_BLOCK, "__body"));
  var _renderButton = function _renderButton(name, buttonType) {
    var text = buttonType.text,
      onClick = buttonType.onClick,
      addlProps = (0, _objectWithoutProperties2.default)(buttonType, _excluded2);
    return /*#__PURE__*/_react.default.createElement(_Button.default, (0, _extends2.default)({}, addlProps, {
      muted: name === 'buttonNegative',
      onClick: (0, _chainFunction.default)(onClick, onHide),
      ref: name === 'buttonPrimary' ? function (node) {
        if (node !== null) {
          node.focus();
        }
      } : null,
      size: buttonSize,
      type: name === 'buttonNegative' ? 'link' : 'default'
    }), text);
  };
  return /*#__PURE__*/_react.default.createElement(_AlertDialogContext.default.Provider, {
    value: true
  }, /*#__PURE__*/_react.default.createElement(_Modal.default, (0, _extends2.default)({}, otherProps, {
    backdropClassName: backdropClasses,
    className: classes,
    onHide: onHide,
    ref: ref,
    size: buttonSecondary ? 'md' : 'sm'
  }), /*#__PURE__*/_react.default.createElement(_Modal.default.Header, {
    className: classnames("".concat(CSS_BLOCK, "__header--").concat(type)),
    closeButton: !hideCloseButton,
    closeLabel: !hideCloseButton && closeButtonLabel
  }, /*#__PURE__*/_react.default.createElement(_Modal.default.Title, null, title)), /*#__PURE__*/_react.default.createElement(_Modal.default.Body, {
    className: bodyClasses
  }, type && /*#__PURE__*/_react.default.createElement(_Icon.default, {
    ariaHidden: true,
    className: classnames(_StyleConfig.CSS_PREFIX, "".concat(CSS_BLOCK, "__icon")),
    iconName: type === 'confirm' ? 'messaging-help' : "messaging-".concat(type),
    size: "lg"
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: classnames(_StyleConfig.CSS_PREFIX, "".concat(CSS_BLOCK, "__content"))
  }, children)), /*#__PURE__*/_react.default.createElement(_Modal.default.Footer, null, buttonNegative && _renderButton('buttonNegative', buttonNegative), buttonSecondary && _renderButton('buttonSecondary', buttonSecondary), _renderButton('buttonPrimary', buttonPrimary))));
});
MessageBox.displayName = 'MessageBox';
MessageBox.propTypes = {
  /** An object identifying the primary response button. The object will include properties
   * for `text` and an `onClick` callback; e.g., `{ text: 'Cancel', onClick: () => {} }`.
   * Any additional props will be passed to **Button**.
   * NOTE: text must be localized. */
  buttonPrimary: _propTypes.default.shape({
    text: _propTypes.default.string,
    onClick: _propTypes.default.func
  }).isRequired,
  /** Callback function when message box is dismissed. */
  onHide: _propTypes.default.func.isRequired,
  /** Localized text used in the `aria-label` attribute on the close (“X”) button.
   * Required if 'hideCloseButton' is false.
  */
  closeButtonLabel: _CustomPropTypes.default.conditionallyRequired(_CustomPropTypes.default.localizedString('CoreUIComponents.close'), function (props) {
    return !props.hideCloseButton;
  }, '`hideCloseButton` is not set'),
  /** Boolean used to hide close (“X”) button */
  hideCloseButton: _propTypes.default.bool,
  /** Custom classes to be added to the backdrop `<div>` tag. */
  backdropClassName: _propTypes.default.string,
  /** An object identifying the negative response button. The object will include properties
   * for `text` and an `onClick` callback; e.g., `{ text: 'Cancel', onClick: () => {} }`.
   * Any additional props will be passed to **Button**.
   * NOTE: text must be localized. */
  buttonNegative: _propTypes.default.shape({
    text: _propTypes.default.string,
    onClick: _propTypes.default.func
  }),
  /** An object identifying the “secondary” response button. The object will include
   * properties for `text` and an `onClick` callback; e.g.,
   * `{ text: 'Cancel', onClick: () => {} }`.
   * Any additional props will be passed to **Button**.
   *  NOTE: text must be localized. */
  buttonSecondary: _propTypes.default.shape({
    text: _propTypes.default.string,
    onClick: _propTypes.default.func
  }),
  /** Size of the buttons in the **MessageBox** footer. Options are 'lg', 'md'. */
  buttonSize: _propTypes.default.oneOf(_StyleConfig.MESSAGEBOX_BUTTON_SIZES),
  /** Collection of React components to be placed in the body of the **MessageBox**.
   * This is typically the message to be displayed. */
  children: _propTypes.default.node,
  /** Custom classes to add to the modal. */
  className: _propTypes.default.string,
  /** Text shown in the header of the **MessageBox**. */
  title: _propTypes.default.string,
  /** The **MessageBox** type. Options are 'confirm', 'success', 'info', 'warning', 'error'. */
  type: _propTypes.default.oneOf(_StyleConfig.MESSAGEBOX_TYPES)
};
MessageBox.defaultProps = {
  buttonSize: 'lg',
  title: '',
  type: 'info'
};
var _default = (0, _reactUiTheming.withThemeStyles)(styles)(MessageBox);
exports.default = _default;